import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  ButtonGroup,
  Chip,
  Divider,
  FormControl,
  FormLabel,
  Typography,
} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import GlobalDateField from "../../global-fields/GlobalDateField";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalRadio from "../../global-fields/GlobalRadio";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import minusIcon from "../../../assets/img/proposal-img/minus_icon.svg";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import dayjs from "dayjs";
import {IoMdClose} from "react-icons/io";
import GlobalErrorMsgBox from "../../global-fields/GlobalErrorMsgBox";
import {setUiData} from "../../../store/uiSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import {
  areRequiredFieldsFilled,
  initialFormValidations,
  removeCookies,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {MANDATORY_QUES} from "../../../constants/constants";
import GlobalModal from "../../global-fields/GlobalModal";
import {FaExternalLinkAlt} from "react-icons/fa";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import {numberSchema,optionalNumberSchema} from "../../../constants/validationSchemas";
import {handleFileUploadWithoutVids} from "../../../constants/helper";
import GlobalTimePickerField from "../../global-fields/GlobalTimePickerField";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import {TbRefresh} from "react-icons/tb";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const ExtentOfProtectionMenuItems = [
  {name: "1", value: 1},
  {name: "2", value: 2},
  {name: "3", value: 3},
];
const GradeMenuItems = [
  {name: "AA", value: "AA"},
  {name: "A", value: "A"},
  {name: "B", value: "B"},
  {name: "C", value: "C"},
];

const StepThreeForm = ({leftGridWidth}) => {
  const MaxLimitNameAddress = 10;
  const MinLimitNameAddress = 1;
  const premisesLimit = 10;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep3Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  // const [totalPremises, setTotalPremises] = useState(1);
  const [disableDraft, setDisableDraft] = useState(false);
  const propStep3DataMemoize = useMemo(() => propStep3Data, [propStep3Data]);

  const initialValues = {
    step: 3,
    premises_protection: propStep3DataMemoize?.premises_protection?.length
      ? propStep3DataMemoize?.premises_protection?.map((item) => ({
          alarm_system: item.alarm_system,
          extent_protection: item.extent_protection ?? null,
          grade: item.grade || "AA",
          protective_company: item.protective_company,
          ul_certificate_no: item.ul_certificate_no ?? "",
          ul_certificate_file: item.ul_certificate_file ?? null, // File input
          certificate_expiry_date: item.certificate_expiry_date,
          hold_up_alarm:
            item?.hold_up_alarm === "1" || item?.hold_up_alarm === 1 ? 1 : 0,
          signal_buttons: item.signal_buttons ?? 0,
          premises_entrance_trap:
            item?.premises_entrance_trap === "1" ||
            item?.premises_entrance_trap === 1
              ? 1
              : 0,
          premises_surveillance_camera:
            item?.premises_surveillance_camera === "1" ||
            item?.premises_surveillance_camera === 1
              ? 1
              : 0,
        }))
      : [
          {
            alarm_system: "",
            extent_protection: 1,
            grade: "AA",
            protective_company: "",
            ul_certificate_no: "",
            ul_certificate_file: null,
            certificate_expiry_date: "",
            hold_up_alarm: 0,
            signal_buttons: 0,
            premises_surveillance_camera: 0,
            premises_entrance_trap: 0,
          },
        ],
    premises_description: propStep3DataMemoize?.premises_description?.length
      ? propStep3DataMemoize?.premises_description?.map((desc) => ({
          entrance_open: desc.entrance_open ?? null,
          entrance_close: desc.entrance_close ?? null,
          business_hours_from: desc.business_hours_from
            ? dayjs(desc.business_hours_from, "HH:mm")
            : "",
          business_hours_to: desc.business_hours_to
            ? dayjs(desc.business_hours_to, "HH:mm")
            : "",
          name_address: desc.name_address?.map((address) => ({
            name: address.name || "",
            street: address.street || "",
            apartment: address.apartment || "",
            city: address.city || "",
            state: address.state || "",
            zip: address.zip || "",
          })) || [
            {
              name: "",
              street: "",
              apartment: "",
              city: "",
              state: "",
              zip: "",
            },
          ],
          key_lock: desc.key_lock || "No",
          showcases_locked: desc.showcases_locked || "Yes",
          premises_shared: desc.premises_shared || "No",
          shared_details: desc.shared_details || "",
        }))
      : [
          {
            entrance_open: null,
            entrance_close: null,
            business_hours_from: "",
            business_hours_to: "",
            name_address: [
              {
                name: "",
                street: "",
                apartment: "",
                city: "",
                state: "",
                zip: "",
              },
            ],
            key_lock: "No",
            showcases_locked: "Yes",
            premises_shared: "No",
            shared_details: "",
          },
        ],
  };

  // useEffect(() => {
  //   if (propStep3DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep3DataMemoize]);

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      step: proposalStep,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }
    const formData = new FormData();
    formData.append("proposal_id", data.proposal_id);

    formData.append("step", data.step);
    formData.append("user_id", data.user_id);
    data?.premises_protection.forEach((item, index) => {
      Object.entries(item).forEach(([key, value]) => {
        if (key === "certificate_expiry_date") {
          formData.append(
            `premises_protection[${index}][${key}]`,
            value ? dayjs(value).format("MM-DD-YYYY") : ""
          );
        } else if (key === "ul_certificate_file") {
          // Append file separately
          if (value instanceof File) {
            formData.append(`premises_protection[${index}][${key}]`, value);
          } else if (value !== null) {
            formData.append(`premises_protection[${index}][${key}]`, value);
          }
        } else {
          formData.append(`premises_protection[${index}][${key}]`, value);
        }
      });
    });
    data?.premises_description.forEach((item, index) => {
      Object.entries(item).forEach(([key, value]) => {
        if (key === "business_hours_from" || key === "business_hours_to") {
          formData.append(
            `premises_description[${index}][${key}]`,
            value ? dayjs(value).format("HH:mm") : "" // Format time to HH:mm
          );
        } else if (Array.isArray(value)) {
          // Handle `name_address` array
          value.forEach((subItem, subIndex) => {
            Object.entries(subItem).forEach(([subKey, subValue]) => {
              formData.append(
                `premises_description[${index}][name_address][${subIndex}][${subKey}]`,
                subValue
              );
            });
          });
        } else {
          formData.append(`premises_description[${index}][${key}]`, value);
        }
      });
    });

    const options = {
      method: PROPOSAL_FORM.method,
      body: formData,
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  // Helper schema to normalize empty string to null
  const requiredString = Yup.string()
    .transform((value) => (value === "" ? null : value))
    .required(MANDATORY_QUES);

  const optionalString = Yup.string().transform((value) =>
    value === "" ? null : value
  );

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      premises_protection: Yup.array().of(
        Yup.object({
          alarm_system: Yup.string()
            .oneOf(["central_station", "local_device"], "Invalid value")
            .required(MANDATORY_QUES),

          extent_protection: Yup.mixed()
            .nullable()
            .test(
              "required",
              MANDATORY_QUES,
              (value) => value !== null && value !== undefined && value !== ""
            ),

          grade: requiredString,
         // protective_company: requiredString,

          ul_certificate_no: optionalString.max(
            33,
            "Maximum 32 Characters Allowed."
          ),

          ul_certificate_file: Yup.mixed()
            .nullable()
            .test("file-or-url", MANDATORY_QUES, (value) => {
              if (!value) return true;
              // if (!value || value === "") return true;
              if (typeof value === "string" && value.includes("https://"))
                return true;
              if (value instanceof File) return true;
              return false;
            }),
          certificate_expiry_date: optionalString,
          // hold_up_alarm: Yup.string()
          //   .oneOf(["Yes", "No"], "Invalid value")
          //   .required(MANDATORY_QUES),
          hold_up_alarm: Yup.number()
            .oneOf([1, 0], "Invalid selection")
            .required(MANDATORY_QUES),
          signal_buttons: numberSchema,
          premises_entrance_trap: Yup.string(),
          premises_surveillance_camera: Yup.string(),
        })
      ),

      premises_description: Yup.array().of(
        Yup.object({
          entrance_open: optionalNumberSchema,
          entrance_close: optionalNumberSchema,

          business_hours_from: Yup.string()
            .transform((value) => (value === "" ? null : value)),
           // .required(MANDATORY_QUES),

          business_hours_to: Yup.string()
            .transform((value) => (value === "" ? null : value)),
           // .required(MANDATORY_QUES),

          key_lock: Yup.string()
            .oneOf(["Yes", "No"], "Invalid value")
            .required(MANDATORY_QUES),

          showcases_locked: Yup.string()
            .oneOf(["Yes", "No", "Not Applicable"], "Invalid value")
            .required(MANDATORY_QUES),

          premises_shared: Yup.string()
            .oneOf(["Yes", "No"], "Invalid value")
            .required(MANDATORY_QUES),

          shared_details: Yup.string()
            .nullable()
            .transform((value) => (value === "" ? null : value))
            .test("sharedDetailsRequired", MANDATORY_QUES, function (value) {
              return this.parent.premises_shared === "Yes"
                ? Boolean(value)
                : true;
            }),

          name_address: Yup.array().of(
            Yup.object({
              name: optionalString
                .nullable()
                .min(2, "Name must be at least 2 characters")
                .max(150, "Name can't exceed 150 characters"),

              street: optionalString
                .nullable()
                .max(100, "Street can't exceed 100 characters"),

              apartment: optionalString
                .nullable()
                .max(100, "Apartment can't exceed 100 characters"),

              city: optionalString
                .nullable()
                .matches(
                  /^[A-Za-z\s]+$/,
                  "Enter a valid city name (Alphabets only)."
                ),

              state: optionalString
                .nullable()
                .matches(
                  /^[A-Za-z\s]+$/,
                  "Enter a valid state name (Alphabets only)."
                ),

              zip: Yup.string()
                .transform((value) => (value === "" ? null : value))
                .nullable()
                .matches(
                  /^\d{5}(-\d{4})?$/,
                  "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
                ),
            })
          ),
        })
      ),
    }),

    onSubmit: (values) => {
      //console.log("Form submitted 3:", values);
      handleStepData(values);
    },
  });

  const handlePlus = useCallback(() => {
    //setTotalPremises((prev) => prev + 1);
    formik.setValues((prevValues) => ({
      premises_protection: [
        ...prevValues?.premises_protection,
        {
          alarm_system: "",
          extent_protection: 1,
          grade: "AA",
          protective_company: "",
          ul_certificate_no: "",
          ul_certificate_file: null,
          certificate_expiry_date: "",
          hold_up_alarm: 0,
          signal_buttons: 0,
        },
      ],
      premises_description: [
        ...prevValues?.premises_description,
        {
          entrance_open: null,
          entrance_close: null,
          // business_hours: null,
          business_hours_from: "",
          business_hours_to: "",
          name_address: [
            {
              name: "",
              street: "",
              apartment: "",
              city: "",
              state: "",
              zip: "",
            },
          ],
          key_lock: "No",
          showcases_locked: "Yes",
          premises_shared: "No",
          shared_details: "",
        },
      ],
    }));
  }, [formik]);

  const handleRemove = useCallback(
    (val) => {
      if (!val) {
        setOpenModal(false);
        setModalContent("");
        return;
      }
      //setTotalPremises((prev) => Math.max(prev - 1, 1)); // Ensures it never goes below 1
      formik.setValues((prevValues) => ({
        premises_protection:
          prevValues?.premises_protection.length > 1
            ? prevValues?.premises_protection.slice(0, -1)
            : prevValues?.premises_protection,
        premises_description:
          prevValues?.premises_description.length > 1
            ? prevValues?.premises_description.slice(0, -1)
            : prevValues?.premises_description,
      }));
      setOpenModal(false);
      setModalContent("");
    },
    [formik]
  );

  const handleConfirmation = (index, type) => {
    setOpenModal(true);
    setModalContent(
      `You Want To Remove Premise ${index ? index + 1 : ""} - Protection & Description.`
    );
  };
  const handlePlusNameAddress = (index) => {
    const nameAddressList =
      formik.values?.premises_description[index].name_address;

    // Get the last entry
    const lastEntry = nameAddressList[nameAddressList.length - 1];

    // Check if the last entry is fully filled
    if (
      !lastEntry ||
      lastEntry.name.trim() === "" ||
      lastEntry.street.trim() === "" ||
      lastEntry.apartment.trim() === "" ||
      lastEntry.city.trim() === "" ||
      lastEntry.state.trim() === "" ||
      lastEntry.zip.trim() === ""
    ) {
      //   alert("Please fill the last Name and Address fields before adding a new one.");
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (nameAddressList.length < MaxLimitNameAddress) {
      formik.setFieldValue(`premises_description[${index}].name_address`, [
        ...nameAddressList,
        {
          name: "",
          street: "",
          apartment: "",
          city: "",
          state: "",
          zip: "",
        },
      ]);
    }
  };

  const handleMinusNameAddress = (index, addressIndex) => {
    if (
      formik.values?.premises_description[index].name_address.length >
      MinLimitNameAddress
    ) {
      const updatedAddresses = formik.values?.premises_description[
        index
      ].name_address.filter((_, i) => i !== addressIndex);
      formik.setFieldValue(
        `premises_description[${index}].name_address`,
        updatedAddresses
      );
    }
  };

  const isErrorFreeArray = (errorsArray) => {
    if (!errorsArray) return true; // no errors present
    if (!Array.isArray(errorsArray)) return false;

    return errorsArray.every((item) => {
      if (!item) return true;
      return typeof item === "object" && Object.keys(item).length === 0;
    });
  };
  const isPremisesProtectionValid = isErrorFreeArray(
    formik.errors?.premises_protection
  );
  const isPremisesDescriptionValid = isErrorFreeArray(
    formik.errors?.premises_description
  );

  // Optional: Add custom field requirement checks here if needed
  const allMandatoryFieldsFilled = areRequiredFieldsFilled(formik); // assuming your function works correctly

  // console.log("AHHHHHHHHH", areRequiredFieldsFilled(formik), isPremisesProtectionValid && isPremisesDescriptionValid);
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 3) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h3 className={style.propo_title}>Premise Protection</h3>

            <Grid size={{xs: 12, md: 12}} sx={{mb: 2}}>
              <div className={style.propoformCountBtn}>
                <p> Number of Premises: </p>
                <div className="countGroupBtn">
                  <ButtonGroup size="small" aria-label="Small button group">
                    <Button
                      variant="contained"
                      onClick={() => handleConfirmation(null)}
                      disabled={formik.values?.premises_protection.length < 2}
                    >
                      -
                    </Button>
                    <Button
                      style={{
                        pointerEvents: "none",
                        borderColor: "rgb(236 236 236)",
                      }}
                    >
                      {/* {totalPremises} */}
                      {formik.values?.premises_protection.length}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handlePlus}
                      disabled={
                        formik.values?.premises_protection.length >=
                        premisesLimit
                      }
                    >
                      +
                    </Button>
                    {/* <Button variant="contained" onClick={handlePlus}  disabled={totalPremises >= premisesLimit}>+</Button> */}
                  </ButtonGroup>
                </div>
              </div>
            </Grid>

            <Grid size={{xs: 12, md: 12}} sx={{mb: 2}}>
              <h2 className={style.formTitleh2}>8) Premises Protection</h2>
            </Grid>
            {formik.values?.premises_protection.map((item, index) => (
              <>
                <Accordion
                  key={index}
                  defaultExpanded={false}
                  className="proposal_accordion"
                  style={
                    formik?.errors?.premises_protection?.length
                      ? {borderColor: "#FF2116"}
                      : {}
                  }
                >
                  <div className="premiseAccordionDiv">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`premises_protection${index + 1}-content`}
                      id={`premises_protection${index + 1}-header`}
                    >
                      <Typography component="h4">
                        Premise {index + 1}
                      </Typography>
                    </AccordionSummary>
                    <Button
                      className={style.premiseCloseBtn}
                      variant="contained"
                      color="error"
                      onClick={() => handleConfirmation(index)}
                      disabled={
                        formik.values?.premises_protection?.length === 1
                      }
                    >
                      <IoMdClose />
                    </Button>
                  </div>

                  <AccordionDetails>
                    <form
                      autoComplete="false"
                      autoSave="false"
                      onSubmit={handleCustomSubmit}
                    >
                      <Grid container spacing={2}>
                        <Grid size={{xs: 12}} sx={{mt: 0}}>
                          <h2
                            style={{color: "#000"}}
                            className={style.formTitleh2}
                          >
                            Electrical Burglar Alarm Systems
                          </h2>
                          <Box sx={{mt: 1}}>
                            <p className={style.htitleText}>
                              Are premises protected by an operating mercantile
                              premises alarm system? *
                            </p>
                          </Box>
                        </Grid>

                        <Grid size={{xs: 12, sm: 6, md: 5, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="Central Station"
                            selected={
                              formik.values?.premises_protection[index]
                                .alarm_system === "central_station"
                            }
                            onClick={() =>
                              formik.setFieldValue(
                                `premises_protection[${index}].alarm_system`,
                                "central_station"
                              )
                            }
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.alarm_system &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.alarm_system
                              )
                            }
                            errorText={
                              formik.touched?.premises_protection?.[index]
                                ?.alarm_system &&
                              formik.errors?.premises_protection?.[index]
                                ?.alarm_system
                            }
                          />
                        </Grid>
                        <Grid size={{xs: 12, sm: 6, md: 5, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="Local Device Only"
                            selected={
                              formik.values?.premises_protection[index]
                                .alarm_system === "local_device"
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue(
                                `premises_protection[${index}].alarm_system`,
                                "local_device"
                              );
                            }}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid
                          size={{xs: 12, lg: 10, xl: 8, sm: 12}}
                          sx={{mt: 3}}
                        >
                          <Grid container spacing={2}>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <Box sx={{mb: 1, color: "#000"}}>
                                Extent of Protection
                              </Box>
                              <GlobalSelectField
                                labelId={`premises_protection.${index}.extent_protection`}
                                value={
                                  formik.values?.premises_protection[index]
                                    ?.extent_protection
                                }
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    `premises_protection.${index}.extent_protection`,
                                    e.target.value
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.premises_protection?.[index]
                                    ?.extent_protection &&
                                  Boolean(
                                    formik.errors?.premises_protection?.[index]
                                      ?.extent_protection
                                  )
                                }
                                helperText={
                                  formik.touched?.premises_protection?.[index]
                                    ?.extent_protection
                                    ? formik.errors?.premises_protection?.[
                                        index
                                      ]?.extent_protection
                                    : ""
                                }
                                menuItems={ExtentOfProtectionMenuItems}
                              />
                            </Grid>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <Box sx={{mb: 1, color: "#000"}}>Grade</Box>

                              <GlobalSelectField
                                labelId={`premises_protection.${index}.grade`}
                                value={
                                  formik.values?.premises_protection[index]
                                    ?.grade || ""
                                }
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    `premises_protection.${index}.grade`,
                                    e.target.value
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.premises_protection?.[index]
                                    ?.grade &&
                                  Boolean(
                                    formik.errors?.premises_protection?.[index]
                                      ?.grade
                                  )
                                }
                                helperText={
                                  formik.touched?.premises_protection?.[index]
                                    ?.grade &&
                                  formik.errors?.premises_protection?.[index]
                                    ?.grade
                                }
                                menuItems={GradeMenuItems}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid size={{xs: 12, lg: 10, xl: 8}} sx={{mt: 3}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            Name of Protective Company *
                          </Box>
                          <GlobalTextField
                            name={`premises_protection[${index}].protective_company`}
                            id={`premises_protection_${index}_protective_company`}
                            value={
                              formik.values?.premises_protection[index]
                                .protective_company
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.protective_company &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.protective_company
                              )
                            }
                            helperText={
                              formik.touched?.premises_protection?.[index]
                                ?.protective_company &&
                              formik.errors?.premises_protection?.[index]
                                ?.protective_company
                            }
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid size={{xs: 12, lg: 10, xl: 8}} sx={{mt: 3}}>
                          <Grid container spacing={2}>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <Box sx={{mb: 1, color: "#000"}}>
                                U.L. Certificate No.
                              </Box>
                              <GlobalTextField
                                name={`premises_protection[${index}].ul_certificate_no`}
                                id={`premises_protection_${index}_ul_certificate_no`}
                                value={
                                  formik.values?.premises_protection?.[index]
                                    ?.ul_certificate_no
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.premises_protection?.[index]
                                    ?.ul_certificate_no &&
                                  Boolean(
                                    formik.errors?.premises_protection?.[index]
                                      ?.ul_certificate_no
                                  )
                                }
                                helperText={
                                  formik.touched?.premises_protection?.[index]
                                    ?.ul_certificate_no &&
                                  formik.errors?.premises_protection?.[index]
                                    ?.ul_certificate_no
                                }
                              />
                            </Grid>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <Box sx={{mb: 1, color: "#000"}}>
                                Date of Expiration
                              </Box>
                              <GlobalDateField
                                name={`premises_protection[${index}].certificate_expiry_date`}
                                value={
                                  formik.values?.premises_protection[index]
                                    .certificate_expiry_date
                                    ? formik.values?.premises_protection[index]
                                        .certificate_expiry_date
                                    : null
                                }
                                onChange={(newValue) =>
                                  formik.setFieldValue(
                                    `premises_protection[${index}].certificate_expiry_date`,
                                    newValue
                                  )
                                }
                                onBlur={formik.handleBlur}
                                //onBlur={() => formik.setFieldTouched(`premises_protection[${index}].certificate_expiry_date`, true)}
                                error={
                                  formik.touched?.premises_protection?.[index]
                                    ?.certificate_expiry_date &&
                                  Boolean(
                                    formik.errors?.premises_protection?.[index]
                                      ?.certificate_expiry_date
                                  )
                                }
                                helperText={
                                  formik.touched?.premises_protection?.[index]
                                    ?.certificate_expiry_date &&
                                  formik.errors?.premises_protection?.[index]
                                    ?.certificate_expiry_date
                                }
                                disablePast
                                clearBtn={
                                  formik.values?.premises_protection[index]
                                    .certificate_expiry_date !== ""
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid
                          size={{xs: 12, lg: 10, xl: 8}}
                          sx={{mt: 3}}
                          className="choosefileBtn"
                        >
                          <Box sx={{color: "#000", mb: 1}}>
                            Enclose U.L. Certificates where issued
                          </Box>
                          <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUploadIcon />}
                          >
                            {formik.values?.premises_protection[index]
                              ?.ul_certificate_file?.name ? (
                              <span>
                                {
                                  formik.values?.premises_protection[index]
                                    ?.ul_certificate_file?.name
                                }
                              </span>
                            ) : formik.values?.premises_protection[
                                index
                              ]?.ul_certificate_file?.includes("https://") ? (
                              <>
                                <span className={style.safeVFile}>
                                  {
                                    formik.values?.premises_protection[
                                      index
                                    ]?.ul_certificate_file.split("/images/")[1]
                                  }
                                </span>
                              </>
                            ) : (
                              "Upload file"
                            )}
                            <VisuallyHiddenInput
                              type="file"
                              accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                              onChange={(event) =>
                                handleFileUploadWithoutVids({
                                  event,
                                  fieldName: `premises_protection[${index}].ul_certificate_file`,
                                  formik,
                                  onError: (message) =>
                                    GlobalNotificationPopup({
                                      type: "error",
                                      message,
                                    }),
                                })
                              }
                            />
                          </Button>

                          <div className={style.fileBtnMain}>
                            {formik.values?.premises_protection[index]
                              ?.ul_certificate_file &&
                            formik.values?.premises_protection[index]
                              .ul_certificate_file !== "" ? (
                              <>
                                <span
                                  style={{
                                    cursor: "pointer",
                                    // marginLeft: "5px",
                                    // backgroundColor: "#004F71",
                                    borderRadius: "10px",
                                    color: "rgb(0 79 113)",
                                    // padding: "3px 5px",
                                    display: "block",
                                    marginTop: "10px",
                                    textAlign: "right",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() => {
                                    if (
                                      formik.values?.premises_protection[index]
                                        ?.ul_certificate_file?.name
                                    ) {
                                      window.open(
                                        URL.createObjectURL(
                                          formik.values?.premises_protection[
                                            index
                                          ].ul_certificate_file
                                        ),
                                        "_blank"
                                      );
                                      return;
                                    }

                                    if (
                                      formik.values?.premises_protection[
                                        index
                                      ]?.ul_certificate_file?.includes(
                                        "https://"
                                      )
                                    ) {
                                      window.open(
                                        formik.values?.premises_protection[
                                          index
                                        ]?.ul_certificate_file,
                                        "_blank"
                                      );
                                    }
                                    return;
                                  }}
                                >
                                  View <MdOutlineRemoveRedEye />
                                </span>
                                <span
                                  style={{
                                    cursor: "pointer",
                                    // marginLeft: "5px",
                                    // backgroundColor: "#004F71",
                                    borderRadius: "10px",
                                    color: "rgb(0 79 113)",
                                    // padding: "3px 5px",
                                    display: "block",
                                    marginTop: "10px",
                                    textAlign: "right",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    // window.open(
                                    //   formik.values?.premises_protection[index]
                                    //     .ul_certificate_file,
                                    //   "_blank"
                                    // )
                                    formik.setFieldValue(
                                      `premises_protection[${index}].ul_certificate_file`,
                                      ""
                                    )
                                  }
                                >
                                  Clear <TbRefresh />
                                </span>
                              </>
                            ) : null}
                          </div>
                          {formik.touched?.premises_protection?.[index]
                            ?.ul_certificate_file &&
                          formik?.errors?.premises_protection?.[index]
                            ?.ul_certificate_file ? (
                            <GlobalErrorMsgBox
                              errMessage={
                                formik?.errors?.premises_protection?.[index]
                                  ?.ul_certificate_file
                              }
                            />
                          ) : null}
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 12}} sx={{mt: 3}}>
                          <h2
                            style={{color: "#000"}}
                            className={style.formTitleh2}
                          >
                            Holdup Alarm and Protective Systems
                          </h2>
                          <Box sx={{color: "#000", mt: 1}}>
                            Is there a Central Station Hold Up Alarm System
                            Protecting the Premises?
                          </Box>
                        </Grid>
                        <Grid size={{xs: 12, md: 5, sm: 6, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="Yes"
                            name={`premises_protection[${index}].hold_up_alarm`}
                            selected={
                              formik.values?.premises_protection?.[index]
                                ?.hold_up_alarm === 1
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setValues((prevValues) => ({
                                ...prevValues,
                                premises_protection:
                                  prevValues?.premises_protection.map(
                                    (item, i) =>
                                      i === index
                                        ? {
                                            ...item,
                                            signal_buttons: 1,
                                            hold_up_alarm: 1,
                                          }
                                        : item
                                  ),
                              }));
                            }}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.hold_up_alarm &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.hold_up_alarm
                              )
                            }
                            errorText={
                              formik.touched?.premises_protection?.[index]
                                ?.hold_up_alarm &&
                              formik.errors?.premises_protection?.[index]
                                ?.hold_up_alarm
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 5, sm: 6, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="No"
                            name={`premises_protection[${index}].hold_up_alarm`}
                            selected={
                              formik.values?.premises_protection?.[index]
                                ?.hold_up_alarm !== 1
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setValues((prevValues) => ({
                                ...prevValues,
                                premises_protection:
                                  prevValues?.premises_protection.map(
                                    (item, i) =>
                                      i === index
                                        ? {
                                            ...item,
                                            signal_buttons: 0,
                                            hold_up_alarm: 0,
                                          }
                                        : item
                                  ),
                              }));
                            }}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.hold_up_alarm &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.hold_up_alarm
                              )
                            }
                            errorText={
                              formik.touched?.premises_protection?.[index]
                                ?.hold_up_alarm &&
                              formik.errors?.premises_protection?.[index]
                                ?.hold_up_alarm
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 5, lg: 5, xl: 4}} sx={{mt: 3}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            No. Of Signal Buttons
                          </Box>
                          <GlobalTextField
                            type="text"
                            name={`premises_protection[${index}].signal_buttons`}
                            id={`premises_protection_${index}_signal_buttons`}
                            value={
                              formik.values?.premises_protection?.[index]
                                ?.signal_buttons
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.signal_buttons &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.signal_buttons
                              )
                            }
                            helperText={
                              formik.touched?.premises_protection?.[index]
                                ?.signal_buttons &&
                              formik.errors?.premises_protection?.[index]
                                ?.signal_buttons
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 12}} sx={{mt: 3}}>
                          <Box sx={{color: "#000"}}>
                            Is the entrance to your premises protected by a cage
                            or a double entrance trap?
                          </Box>
                        </Grid>
                        <Grid size={{xs: 12, md: 5, sm: 6, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="Yes"
                            name={`premises_protection[${index}].premises_entrance_trap`}
                            selected={
                              formik.values?.premises_protection?.[index]
                                ?.premises_entrance_trap === 1
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue(
                                `premises_protection[${index}].premises_entrance_trap`,
                                1
                              );
                            }}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_entrance_trap &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.premises_entrance_trap
                              )
                            }
                            helperText={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_entrance_trap &&
                              formik.errors?.premises_protection?.[index]
                                ?.premises_entrance_trap
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 5, sm: 6, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="No"
                            name={`premises_protection[${index}].premises_entrance_trap`}
                            selected={
                              formik.values?.premises_protection?.[index]
                                ?.premises_entrance_trap !== 1
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue(
                                `premises_protection[${index}].premises_entrance_trap`,
                                0
                              );
                            }}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_entrance_trap &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.premises_entrance_trap
                              )
                            }
                            helperText={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_entrance_trap &&
                              formik.errors?.premises_protection?.[index]
                                ?.premises_entrance_trap
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 12}} sx={{mt: 3}}>
                          <Box sx={{color: "#000"}}>
                            Is your premises monitored by Closed Circuit TV or
                            Surveillance Camera?
                          </Box>
                        </Grid>
                        <Grid size={{xs: 12, md: 5, sm: 6, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="Yes"
                            name={`premises_protection[${index}].premises_surveillance_camera`}
                            selected={
                              formik.values?.premises_protection?.[index]
                                ?.premises_surveillance_camera === 1
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue(
                                `premises_protection[${index}].premises_surveillance_camera`,
                                1
                              );
                            }}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_surveillance_camera &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.premises_surveillance_camera
                              )
                            }
                            helperText={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_surveillance_camera &&
                              formik.errors?.premises_protection?.[index]
                                ?.premises_surveillance_camera
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 5, sm: 6, lg: 5, xl: 4}}>
                          <GlobalRadio
                            title="No"
                            name={`premises_protection[${index}].premises_surveillance_camera`}
                            selected={
                              formik.values?.premises_protection?.[index]
                                ?.premises_surveillance_camera !== 1
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue(
                                `premises_protection[${index}].premises_surveillance_camera`,
                                0
                              );
                            }}
                            error={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_surveillance_camera &&
                              Boolean(
                                formik.errors?.premises_protection?.[index]
                                  ?.premises_surveillance_camera
                              )
                            }
                            helperText={
                              formik.touched?.premises_protection?.[index]
                                ?.premises_surveillance_camera &&
                              formik.errors?.premises_protection?.[index]
                                ?.premises_surveillance_camera
                            }
                          />
                        </Grid>
                      </Grid>
                    </form>
                  </AccordionDetails>
                </Accordion>
                {formik?.errors?.premises_protection?.length ? (
                  <small style={{color: "#FF2116"}}>
                    Mandatory Fields Are Missing!
                  </small>
                ) : null}
              </>
            ))}
            <Grid container spacing={2}>
              <Grid size={{xs: 12, md: 12}} sx={{mt: 1}}>
                <h2 className={style.formTitleh2}>
                  9) Description of Premises
                </h2>
              </Grid>
            </Grid>
            {formik.values?.premises_description.map((premisesDes, index) => (
              <>
                <Accordion
                  key={index}
                  defaultExpanded={false}
                  className="proposal_accordion"
                  style={
                    formik?.errors?.premises_description?.length
                      ? {borderColor: "#FF2116"}
                      : {}
                  }
                >
                  <div className="premiseAccordionDiv">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`premises_description${index + 1}-content`}
                      id={`premises_description${index + 1}-header`}
                    >
                      <Typography component="h4">
                        Premise {index + 1}
                      </Typography>
                    </AccordionSummary>
                    <Button
                      className={style.premiseCloseBtn}
                      variant="contained"
                      color="error"
                      onClick={() => handleConfirmation(index)}
                      disabled={
                        formik.values?.premises_description?.length === 1
                      }
                    >
                      <IoMdClose />
                    </Button>
                  </div>

                  <AccordionDetails>
                    <form
                      autoComplete="false"
                      autoSave="false"
                      onSubmit={handleCustomSubmit}
                    >
                      <Grid container spacing={2} sx={{mt: 2}}>
                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          <Box sx={{color: "#000", mb: 2}}>
                            <h3 className={style.htitleText}>
                              The numbers of entrances that are
                              <strong> open</strong> to the general public. 
                            </h3>
                          </Box>
                          <GlobalTextField
                            name={`premises_description[${index}].entrance_open`}
                            id={`premises_description_${index}_entrance_open`}
                            type="text"
                            // value={
                            //   formik.values?.premises_description[index]
                            //     ?.entrance_open
                            // }
                            value={
                                formik.values?.premises_description[index]?.entrance_open === null ||
                                formik.values?.premises_description[index]?.entrance_open === "null"
                                  ? ""
                                  : formik.values?.premises_description[index]?.entrance_open
                              }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.premises_description?.[index]
                                ?.entrance_open &&
                              Boolean(
                                formik.errors?.premises_description?.[index]
                                  ?.entrance_open
                              )
                            }
                            helperText={
                              formik.touched?.premises_description?.[index]
                                ?.entrance_open &&
                              formik.errors?.premises_description?.[index]
                                ?.entrance_open
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          <Box sx={{color: "#000", mb: 2}}>
                            <h3 className={style.htitleText}>
                              The numbers of entrances that are
                              <strong> not open</strong> to the general public.
                              *
                            </h3>
                          </Box>
                          <GlobalTextField
                            name={`premises_description[${index}].entrance_close`}
                            id={`premises_description_${index}_entrance_close`}
                            type="text"
                            // value={
                            //   formik.values?.premises_description[index]
                            //     ?.entrance_close ?? ""
                            // }
                            value={
                                formik.values?.premises_description[index]?.entrance_close === null ||
                                formik.values?.premises_description[index]?.entrance_close === "null"
                                  ? ""
                                  : formik.values?.premises_description[index]?.entrance_close
                              }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.premises_description?.[index]
                                ?.entrance_close &&
                              Boolean(
                                formik.errors?.premises_description?.[index]
                                  ?.entrance_close
                              )
                            }
                            helperText={
                              formik.touched?.premises_description?.[index]
                                ?.entrance_close &&
                              formik.errors?.premises_description?.[index]
                                ?.entrance_close
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          <Box sx={{color: "#000", mb: 2}}>
                            <h3 className={style.htitleText}>
                              Our usual business hours are 
                            </h3>
                          </Box>
                          <Grid container spacing={2} sx={{mt: 1}}>
                            <Grid size={{xs: 12, md: 6}}>
                              <GlobalTimePickerField
                                title={"From"}
                                id={`premises_description_${index}_business_hours_from`}
                                name={`premises_description[${index}].business_hours_from`}
                                value={
                                  formik.values?.premises_description[index]
                                    ?.business_hours_from
                                }
                                onChange={(newValue) =>
                                  formik.setFieldValue(
                                    `premises_description[${index}].business_hours_from`,
                                    newValue
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.premises_description?.[index]
                                    ?.business_hours_from &&
                                  Boolean(
                                    formik.errors?.premises_description?.[index]
                                      ?.business_hours_from
                                  )
                                }
                                helperText={
                                  formik.touched?.premises_description?.[index]
                                    ?.business_hours_from &&
                                  formik.errors?.premises_description?.[index]
                                    ?.business_hours_from
                                }
                                clearBtn={
                                  formik.values?.premises_description[index]
                                    ?.business_hours_from !== ""
                                }
                              />
                            </Grid>
                            <Grid size={{xs: 12, md: 6}}>
                              <GlobalTimePickerField
                                title={"To"}
                                id={`premises_description_${index}_business_hours_to`}
                                name={`premises_description[${index}].business_hours_to`}
                                value={
                                  formik.values?.premises_description[index]
                                    ?.business_hours_to
                                }
                                onChange={(newValue) =>
                                  formik.setFieldValue(
                                    `premises_description[${index}].business_hours_to`,
                                    newValue
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.premises_description?.[index]
                                    ?.business_hours_to &&
                                  Boolean(
                                    formik.errors?.premises_description?.[index]
                                      ?.business_hours_to
                                  )
                                }
                                helperText={
                                  formik.touched?.premises_description?.[index]
                                    ?.business_hours_to &&
                                  formik.errors?.premises_description?.[index]
                                    ?.business_hours_to
                                }
                                minTime={
                                  formik.values?.premises_description[index]
                                    ?.business_hours_from
                                }
                                clearBtn={
                                  formik.values?.premises_description[index]
                                    ?.business_hours_to !== ""
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          <Box sx={{color: "#000", mb: 0, mt: 1}}>
                            <h3 className={style.htitleText}>
                              Give names and address of other locations of the
                              proposer & other concerns engaged in the Jewelry
                              trade under the same ownership or management as
                              the proposer & not included in this proposal.
                            </h3>
                          </Box>
                        </Grid>
                      </Grid>

                      {premisesDes.name_address.map((address, addressIndex) => (
                        <Grid
                          container
                          spacing={2}
                          sx={{mt: 1}}
                          key={`${index}-${addressIndex}`}
                        >
                          <Grid size={{xs: 12, lg: 10, xl: 8}}>
                            {addressIndex !== 0 && (
                              <Box sx={{width: "100%", mt: 1, mb: 1}}>
                                <Divider>
                                  <Chip
                                    label={`${addressIndex + 1}`}
                                    size="medium"
                                    onDelete={() =>
                                      handleMinusNameAddress(
                                        index,
                                        addressIndex
                                      )
                                    }
                                  />
                                </Divider>
                              </Box>
                            )}
                            <div style={{width: "100%"}}>
                              <Box sx={{color: "#000", mb: 1}}>
                                <div className={style.plusIconMain}>
                                  <FormLabel
                                    className={style.labelText}
                                    sx={{mb: 1}}
                                  >
                                    Name
                                  </FormLabel>

                                  <div className={style.plusImgMain}>
                                    {/* Remove Icon - Show on all indices except the first one */}
                                    {/* {addressIndex !== 0 &&
                                    formik.values?.premises_description[index]
                                      .name_address.length >
                                      MinLimitNameAddress && (
                                      <p
                                        style={{
                                          position: "inherit",
                                          display: "flex",
                                        }}
                                        onClick={() =>
                                          handleMinusNameAddress(
                                            index,
                                            addressIndex
                                          )
                                        }
                                      >
                                        <img
                                          src={minusIcon}
                                          alt="Remove"
                                          style={{marginRight: "5px"}}
                                        />
                                        Remove
                                      </p>
                                    )} */}

                                    {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                                    {addressIndex === 0 &&
                                      formik.values?.premises_description[index]
                                        .name_address.length <
                                        MaxLimitNameAddress && (
                                        <p
                                          style={{
                                            position: "inherit",
                                            display: "flex",
                                          }}
                                          onClick={() =>
                                            handlePlusNameAddress(index)
                                          }
                                        >
                                          <img
                                            src={plusIcon}
                                            alt="Add"
                                            style={{marginRight: "5px"}}
                                          />
                                          Add
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </Box>

                              <GlobalTextField
                                name={`premises_description[${index}].name_address[${addressIndex}].name`}
                                id={`premises_description_${index}_name_address_${addressIndex}_name`}
                                type="text"
                                value={
                                  formik.values?.premises_description[index]
                                    .name_address[addressIndex]?.name
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={Boolean(
                                  formik.touched?.premises_description?.[index]
                                    ?.name_address?.[addressIndex]?.name &&
                                    formik.errors?.premises_description?.[index]
                                      ?.name_address?.[addressIndex]?.name
                                )}
                                helperText={
                                  formik.touched?.premises_description?.[index]
                                    ?.name_address?.[addressIndex]?.name &&
                                  formik.errors?.premises_description?.[index]
                                    ?.name_address?.[addressIndex]?.name
                                }
                              />
                            </div>
                          </Grid>

                          <Grid size={{xs: 12, lg: 10, xl: 8}}>
                            <Grid container spacing={2} sx={{mt: 1}}>
                              <Grid size={{xs: 12, md: 6}}>
                                <div style={{width: "100%"}}>
                                  <FormControl fullWidth>
                                    <FormLabel sx={{mb: 1}}>
                                      Street Name
                                    </FormLabel>
                                  </FormControl>
                                  <GlobalTextField
                                    name={`premises_description[${index}].name_address[${addressIndex}].street`}
                                    id={`premises_description_${index}_name_address_${addressIndex}_.street`}
                                    type="text"
                                    value={
                                      formik.values?.premises_description[index]
                                        .name_address[addressIndex]?.street
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.street &&
                                        formik.errors?.premises_description?.[
                                          index
                                        ]?.name_address?.[addressIndex]?.street
                                    )}
                                    helperText={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.street &&
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.street
                                    }
                                  />
                                </div>
                              </Grid>
                              <Grid size={{xs: 12, md: 6, sm: 6}}>
                                <div style={{width: "100%"}}>
                                  <FormControl fullWidth>
                                    <FormLabel sx={{mb: 1}}>
                                      Apartment/Suite/Floor
                                    </FormLabel>
                                  </FormControl>
                                  <GlobalTextField
                                    name={`premises_description[${index}].name_address[${addressIndex}].apartment`}
                                    id={`premises_description_${index}_name_address_${addressIndex}_apartment`}
                                    type="text"
                                    value={
                                      formik.values?.premises_description[index]
                                        .name_address[addressIndex]?.apartment
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]
                                        ?.apartment &&
                                        formik.errors?.premises_description?.[
                                          index
                                        ]?.name_address?.[addressIndex]
                                          ?.apartment
                                    )}
                                    helperText={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]
                                        ?.apartment &&
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.apartment
                                    }
                                  />
                                </div>
                              </Grid>
                              <Grid size={{xs: 12, md: 4, sm: 6}}>
                                <div style={{width: "100%"}}>
                                  <FormControl fullWidth>
                                    <FormLabel sx={{mb: 1}}> State </FormLabel>
                                  </FormControl>
                                  <GlobalTextField
                                    name={`premises_description[${index}].name_address[${addressIndex}].state`}
                                    id={`premises_description_${index}_name_address_${addressIndex}_state`}
                                    type="text"
                                    value={
                                      formik.values?.premises_description[index]
                                        .name_address[addressIndex]?.state
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.state &&
                                        formik.errors?.premises_description?.[
                                          index
                                        ]?.name_address?.[addressIndex]?.state
                                    )}
                                    helperText={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.state &&
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.state
                                    }
                                  />
                                </div>
                              </Grid>
                              <Grid size={{xs: 12, md: 4, sm: 6}}>
                                <div style={{width: "100%"}}>
                                  <FormControl fullWidth>
                                    <FormLabel sx={{mb: 1}}> City </FormLabel>
                                  </FormControl>
                                  <GlobalTextField
                                    name={`premises_description[${index}].name_address[${addressIndex}].city`}
                                    id={`premises_description_${index}_name_address_${addressIndex}_city`}
                                    type="text"
                                    value={
                                      formik.values?.premises_description[index]
                                        .name_address[addressIndex]?.city
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.city &&
                                        formik.errors?.premises_description?.[
                                          index
                                        ]?.name_address?.[addressIndex]?.city
                                    )}
                                    helperText={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.city &&
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.city
                                    }
                                  />
                                </div>
                              </Grid>

                              <Grid size={{xs: 12, md: 4, sm: 6}}>
                                <div style={{width: "100%"}}>
                                  <FormControl fullWidth>
                                    <FormLabel sx={{mb: 1}}>Zip Code</FormLabel>
                                  </FormControl>
                                  <GlobalTextField
                                    name={`premises_description[${index}].name_address[${addressIndex}].zip`}
                                    id={`premises_description_${index}_name_address_${addressIndex}_zip`}
                                    type="text"
                                    value={
                                      formik.values?.premises_description[index]
                                        .name_address[addressIndex]?.zip
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.zip &&
                                        formik.errors?.premises_description?.[
                                          index
                                        ]?.name_address?.[addressIndex]?.zip
                                    )}
                                    helperText={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.zip &&
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.name_address?.[addressIndex]?.zip
                                    }
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12, lg: 10, md: 10, xl: 8}}>
                          <Grid container spacing={2}>
                            <Grid size={{xs: 12, md: 12}}>
                              <Grid container spacing={2}>
                                <Grid size={{xs: 12, md: 12}}>
                                  <h3 className={style.htitleText}>
                                    Are inside showcases kept equipped with key
                                    lock?
                                  </h3>
                                </Grid>

                                <Grid
                                  size={{xs: 12, lg: 5, md: 5, sm: 6, xl: 4}}
                                >
                                  <GlobalRadio
                                    title="Yes"
                                    selected={
                                      formik.values?.premises_description[index]
                                        ?.showcases_locked === "Yes"
                                    }
                                    onClick={(e) => {
                                      e.preventDefault();
                                      formik.setFieldValue(
                                        `premises_description[${index}].showcases_locked`,
                                        "Yes"
                                      );
                                    }}
                                    error={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.showcases_locked &&
                                      Boolean(
                                        formik.errors?.premises_description?.[
                                          index
                                        ]?.showcases_locked
                                      )
                                    }
                                    errorText={
                                      formik.touched?.premises_description?.[
                                        index
                                      ]?.showcases_locked &&
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.showcases_locked
                                    }
                                  />
                                </Grid>
                                <Grid
                                  size={{xs: 12, lg: 5, md: 5, sm: 6, xl: 4}}
                                >
                                  <GlobalRadio
                                    title="No"
                                    selected={
                                      formik.values?.premises_description[index]
                                        ?.showcases_locked === "No"
                                    }
                                    onClick={(e) => {
                                      e.preventDefault();
                                      formik.setFieldValue(
                                        `premises_description[${index}].showcases_locked`,
                                        "No"
                                      );
                                    }}
                                  />
                                </Grid>
                                <Grid
                                  size={{xs: 12, lg: 5, md: 5, sm: 6, xl: 4}}
                                >
                                  <GlobalRadio
                                    title="Not Applicable"
                                    selected={
                                      formik.values?.premises_description[index]
                                        ?.showcases_locked === "Not Applicable"
                                    }
                                    onClick={(e) => {
                                      e.preventDefault();
                                      formik.setFieldValue(
                                        `premises_description[${index}].showcases_locked`,
                                        "Not Applicable"
                                      );
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12, lg: 10, md: 10, xl: 8}}>
                          <h3 className={style.htitleText}>
                            Do you share your premises?
                          </h3>
                          <Grid container spacing={2} sx={{mt: 2}}>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <GlobalRadio
                                title="Yes"
                                selected={
                                  formik.values?.premises_description[index]
                                    ?.premises_shared === "Yes"
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  formik.setFieldValue(
                                    `premises_description[${index}].premises_shared`,
                                    "Yes"
                                  );
                                }}
                                error={
                                  formik.touched?.premises_description?.[index]
                                    ?.premises_shared &&
                                  Boolean(
                                    formik.errors?.premises_description?.[index]
                                      ?.premises_shared
                                  )
                                }
                                errorText={
                                  formik.touched?.premises_description?.[index]
                                    ?.premises_shared &&
                                  formik.errors?.premises_description?.[index]
                                    ?.premises_shared
                                }
                              />
                            </Grid>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <GlobalRadio
                                title="No"
                                selected={
                                  formik.values?.premises_description[index]
                                    ?.premises_shared === "No"
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  formik.setValues((prevValues) => ({
                                    ...prevValues,
                                    premises_description:
                                      prevValues.premises_description.map(
                                        (item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                premises_shared: "No",
                                                shared_details: "",
                                              }
                                            : item
                                      ),
                                  }));
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {formik.values?.premises_description[index]
                          ?.premises_shared === "Yes" ? (
                          <Grid size={{xs: 12, md: 5, xl: 6}}>
                            <h3 className={style.htitleText}>
                              Please do specify *
                            </h3>
                            <Grid container spacing={2}>
                              <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                                <GlobalTextField
                                  name={`premises_description[${index}].shared_details`}
                                  id={`premises_description_${index}_shared_details`}
                                  type="text"
                                  placeH={
                                    formik.values?.premises_description[index]
                                      ?.premises_shared === "No"
                                      ? "No Premises Shared."
                                      : ""
                                  }
                                  value={
                                    formik.values?.premises_description[index]
                                      ?.shared_details
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.premises_description?.[
                                      index
                                    ]?.shared_details &&
                                    Boolean(
                                      formik.errors?.premises_description?.[
                                        index
                                      ]?.shared_details
                                    )
                                  }
                                  helperText={
                                    formik.touched?.premises_description?.[
                                      index
                                    ]?.shared_details &&
                                    formik.errors?.premises_description?.[index]
                                      ?.shared_details
                                  }
                                  disabled={
                                    formik.values?.premises_description[index]
                                      ?.premises_shared === "No"
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                    </form>
                  </AccordionDetails>
                </Accordion>
                {formik?.errors?.premises_description?.length ? (
                  <small style={{color: "#FF2116"}}>
                    Mandatory Fields Are Missing!
                  </small>
                ) : null}
              </>
            ))}
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            formik.values?.premises_protection[0].protective_company &&
            formik.values?.premises_description[0].entrance_close !== "" &&
            isPremisesProtectionValid &&
            isPremisesDescriptionValid &&
            allMandatoryFieldsFilled &&
            !formik.dirty &&
            propStep3DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
        <GlobalModal
          open={openModal}
          maxWidth="sm"
          handleClose={() => setOpenModal(false)}
          aria-labelledby="claim-history"
          closeIcon={true}
          title={"Are you sure?"}
          dialogTitleClass={style.claimPopTitle}
          disableBackdropClick={false}
          dialogContent={
            <Grid container spacing={0}>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center", mb: 3}}>
                <p>{modalContent}</p>
              </Grid>
              <Grid
                size={{xs: 12, md: 12}}
                sx={{textAlign: "center"}}
                className={style.consentContentBtn}
              >
                <Button
                  variant="contained"
                  sx={{mr: 2}}
                  onClick={() => handleRemove(true)}
                >
                  YES
                </Button>
                <Button variant="contained" onClick={() => handleRemove(false)}>
                  NO
                </Button>
              </Grid>
            </Grid>
          }
        ></GlobalModal>
      </section>
    </>
  );
};

export default StepThreeForm;
